import LocationPinIcon from "@mui/icons-material/LocationPin";
import DoorFrontIcon from "@mui/icons-material/DoorFront";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HomePage from "./HomePage/HomePage";
import LocationPage from "./LocationPage/LocationPage";
import FacilityPage from "./FacilityPage/FacilityPage";
import ContactPage from "./ContactPage/ContactPage";
import PersonelPage from "./PersonelPage/PersonelPage";
import ServicesPage from "./ServicesPage/ServicesPage";

export const pages = [
  { label: "Αρχική", path: "/", navicon: null, component: <HomePage /> },
  {
    label: "Θεραπείες",
    path: "/services",
    navicon: <FavoriteIcon />,
    component: <ServicesPage />,
  },
  {
    label: "Προσωπικό",
    path: "/personel",
    navicon: <PersonIcon />,
    component: <PersonelPage />,
  },
  {
    label: "Ο Χώρος μας",
    path: "/facility",
    navicon: <DoorFrontIcon />,
    component: <FacilityPage />,
  },
  {
    label: "Τοποθεσία",
    path: "/location",
    navicon: <LocationPinIcon />,
    component: <LocationPage />,
  },
  {
    label: "Επικοινωνία",
    path: "/contact",
    navicon: <PhoneIcon />,
    component: <ContactPage />,
  },
];
